import React, { useEffect, useMemo, useState } from "react";
import { EncryptionService } from "../../services/EncryptionService";
import Button2 from "../Button2/Button2";
import { getContractsUrl } from "../../config";

export interface UserData {
  source: string;
  company: string;
  firstname: string;
  lastname: string;
  phone: string;
  email: string;
  title: string;
  id: string;
  entityId: string;
  streetaddress: string;
  streetaddress2: string;
  city: string;
  state: string;
  zip: string;
  contractAdmin: string;
}

const ContractingRedirect: React.FC<UserData> = (props) => {
  const [encryptionService] = useState(() => new EncryptionService());
  const [userData, setUserData] = useState<UserData | null>(null);

  useEffect(() => {
    encryptionService
      .loadPublicKey()
      .catch((err) => console.error("Failed to load public key:", err));
  }, [encryptionService]);

  // 🔁 Sync whenever props change (this is the missing piece)
  useEffect(() => {
    setUserData({
      source: "Contracts<32Gem$",
      company: String(props.company),
      firstname: String(props.firstname),
      lastname: String(props.lastname),
      phone: String(props.phone),
      email: String(props.email),
      title: String(props.title),
      id: String(props.id),
      entityId: String(props.entityId),
      streetaddress: String(props.streetaddress),
      streetaddress2: String(props.streetaddress2),
      city: String(props.city),
      state: String(props.state),
      zip: String(props.zip),
      contractAdmin: String(props.contractAdmin),
    });
  }, [
    props.source,
    props.company,
    props.firstname,
    props.lastname,
    props.phone,
    props.email,
    props.title,
    props.id,
    props.entityId,
    props.streetaddress,
    props.streetaddress2,
    props.city,
    props.state,
    props.zip,
    props.contractAdmin,
  ]);

  const encryptField = (value: string): string =>
    encryptionService.encryptField(value);

  const OnClick = async () => {
    if (!userData) {
      alert("User data not ready");
      return;
    }

    const contractsUrl = getContractsUrl();

    if (!encryptionService.getPublicKey()) {
      alert("Public key not loaded");
      return;
    }

    const fieldMap: Record<keyof UserData, string> = {
      source: "r",
      company: "a",
      firstname: "b",
      lastname: "c",
      phone: "d",
      email: "e",
      title: "f",
      id: "g",
      entityId: "i",
      contractAdmin: "j",
      streetaddress: "k",
      city: "l",
      state: "m",
      zip: "n",
      streetaddress2: "q",
    };

    const encryptedParams = (Object.keys(userData) as (keyof UserData)[]).map(
      (key) =>
        `${fieldMap[key]}=${encodeURIComponent(encryptField(userData[key]))}`,
    );

    const finalUrl = `${contractsUrl}/?${encryptedParams.join("&")}`;
    console.log(finalUrl);
    window.location.href = finalUrl;
  };

  return (
    <Button2
      name="Agreements"
      text="My Agreements"
      onClick={OnClick}
      classname="ctaButton"
    />
  );
};

export default ContractingRedirect;
